import React, { FC, ReactNode } from "react";
import styles from "./matter-editor-generic-tab.module.css";
import { Typography } from "antd";

const {
  ["container"]: containerClassName,
  ["title-section"]: titleSection,
  ["body-section"]: bodySection,
} = styles as any;

export type MatterEditorGenericTabProps = {
  children?: ReactNode;
  title?: string;
};

export const MatterEditorGenericTab: FC<MatterEditorGenericTabProps> = ({ title, children }) => {
  return (
    <div className={containerClassName}>
      {title && (
        <div className={titleSection}>
          <Typography.Text>{title}</Typography.Text>
        </div>
      )}
      <div className={bodySection}>{children}</div>
    </div>
  );
};
